/* =============================================================================
   beUNIQ — "Why you'll love it" reveal

   One job: add .is-in once the panel has been scrolled to, so CSS can run the
   reveal. Everything else — the unroll wipe, the staggered lines, the cycle
   that links each quality to its photograph — is CSS, so this stays tiny.

   The observer disconnects after firing: the reveal plays once, not every time
   the panel scrolls back into view.

   With no IntersectionObserver, or with reduced motion preferred, the panel is
   simply marked revealed immediately and CSS skips the animation.
   ========================================================================== */

(() => {
  'use strict'

  const reduced = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches

  class BeuniqFeatures extends HTMLElement {
    connectedCallback() {
      if (reduced || !('IntersectionObserver' in window)) return this.reveal()

      this.observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              this.reveal()
              this.observer.disconnect()
            }
          }
        },
        // Start a little before it reaches the viewport so the reveal is
        // already under way by the time it is properly in view.
        { rootMargin: '0px 0px -12% 0px', threshold: 0.15 }
      )
      this.observer.observe(this)
    }

    disconnectedCallback() {
      this.observer?.disconnect()
    }

    reveal() {
      this.classList.add('is-in')
    }
  }

  if (!customElements.get('beuniq-features')) {
    customElements.define('beuniq-features', BeuniqFeatures)
  }
})()
